import { render, staticRenderFns } from "./TransferenciaPDF.vue?vue&type=template&id=308244a2&scoped=true"
import script from "./TransferenciaPDF.vue?vue&type=script&lang=js"
export * from "./TransferenciaPDF.vue?vue&type=script&lang=js"
import style0 from "./TransferenciaPDF.vue?vue&type=style&index=0&id=308244a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308244a2",
  null
  
)

export default component.exports